import React from "react"
import CustomMarkdown from "components/atoms/CustomMarkdown"
import { useLang } from "hooks/useLang"
import { IFinalEvent } from "types/event"
import FadeOutEffect from "components/atoms/FadeOutEffect"

interface IProps {
    event: IFinalEvent
}

const EventTerms = ({ event }: IProps) => {
    const { multiLangVars, lang, isAr } = useLang()

    const externalUrl =
        event?._id === "67c5b6b4be4244cce7e53fdf" &&
        (lang === "ar"
            ? "https://saudiarabiangp.com/ar/support-faq"
            : "https://saudiarabiangp.com/en/support-faq")

    //const termsKey = multiLangVars("termsAndConditions") as
    //  | "ar_termsAndConditions"
    // | "en_termsAndConditions"

    return (
        <div id="event-terms">
            <FadeOutEffect
                externalLink={externalUrl as string}
                fadeStartAt={100}
                fadeHeight={100}
            >
                <CustomMarkdown
                    className="text-white text-[14px] md:text-[20px] leading-relaxed"
                    content={
                        isAr
                            ? event?.ar_termsAndConditions
                            : event?.en_termsAndConditions
                    }
                />
            </FadeOutEffect>
        </div>
    )
}

export default EventTerms
